import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['next', 'previous', 'slide', 'finish', 'progress', 'progressStep', 'slideContainer'];
  static values = {
    hiddenClass: { type: String, default: 'hidden' },
    currentSlide: { type: Number, default: 0 },
  };

  connect() {
    this.slideCount = this.slideTargets.length;
    this.rerender();
  }

  previous(event) {
    event.preventDefault();
    if (event.currentTarget.disabled) return;

    if (this.currentSlideValue > 0) {
      this.slideContainerTarget.scrollTop = 0;
      this.currentSlideValue = this.currentSlideValue - 1;
      this.rerender();
    }
  }

  next(event) {
    event.preventDefault();
    if (event.currentTarget.disabled) return;

    if (this.currentSlideValue < this.slideCount - 1) {
      this.slideContainerTarget.scrollTop = 0;
      this.currentSlideValue = this.currentSlideValue + 1;
      this.rerender();
    }
  }

  rerender() {
    this.updateButtons();
    this.updateSlides();
    this.updateProgress();
    this.dispatch('rerender');
  }

  updateButtons() {
    this.setDisabled(this.nextTarget, this.currentSlideValue >= this.slideCount - 1);
    this.setHidden(this.nextTarget, this.currentSlideValue >= this.slideCount - 1);
    this.setHidden(this.finishTarget, this.currentSlideValue < this.slideCount - 1);
    this.setDisabled(this.previousTarget, this.currentSlideValue <= 0);
  }

  updateProgress() {
    this.progressStepTargets.forEach((step) => {
      if (Number(step.dataset.index) <= this.currentSlideValue) {
        step.classList.add('finished');
      } else {
        step.classList.remove('finished');
      }
    });
  }

  updateSlides() {
    this.slideTargets.forEach((slide, index) => {
      slide.classList.toggle(this.hiddenClassValue, index !== this.currentSlideValue);
    });
  }

  setHidden(button, value) {
    if (value) {
      button.classList.add('hidden');
    } else {
      button.classList.remove('hidden');
    }
  }

  setDisabled(button, value) {
    if (value) {
      button.setAttribute('disabled', true);
      button.setAttribute('aria-disabled', true);
    } else {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
    }
  }
}
